import SortingButtonView from "../view/sorting-button.js";
import SortingFormView from "../view/sorting-form.js";

import SortingModel from "../model/sorting.js";

import {
  SORT_KEY,
  defaultSortingModelData,
  ActionType,
  SortDir
} from "../../const.js";
export default class Sorting {
  constructor(buttons, sortingForm, changeFilter, browserNavigation) {
    this._buttons = buttons;
    this._sortingForm = sortingForm;
    this._changeFilter = changeFilter;
    this._browserNavigation = browserNavigation;

    this._buttonsViews = [];
    this._sortingFormView = null;
    this._sortingModel = null;

    this._handleButtonClick = this._handleButtonClick.bind(this);
    this._handleFormChange = this._handleFormChange.bind(this);
    this._handleBrowserNavigation = this._handleBrowserNavigation.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
    this._handleChangeFilterLoadStart = this._handleChangeFilterLoadStart.bind(this);
    this._handleChangeFilterLoad = this._handleChangeFilterLoad.bind(this);
    this._handleChangeFilterLoadEnd = this._handleChangeFilterLoadEnd.bind(this);
  }

  init() {
    Array.from(this._buttons)
      .forEach((button, index) => {
        const view = new SortingButtonView(button, index);
        view.setClickHandler(this._handleButtonClick);
        this._buttonsViews.push(view);
      });

    const activeButtonView = this._buttonsViews
      .find((view) => {
        return view.isActive();
      });
    const sortName = activeButtonView.getSortName();
    const sortDir = activeButtonView.getSortDir();

    this._sortingFormView = new SortingFormView(this._sortingForm);
    this._sortingFormView.setFormChangeHandler(this._handleFormChange);

    this._sortingModel = new SortingModel(Object.assign(
        {},
        defaultSortingModelData,
        {
          sortName,
          sortDir
        }
    ));
    this._sortingModel.addObserver(this._handleChangeData);

    this._changeFilter.addLoadStartObserver(this._handleChangeFilterLoadStart);
    this._changeFilter.addLoadObserver(this._handleChangeFilterLoad);
    this._changeFilter.addLoadEndObserver(this._handleChangeFilterLoadEnd);

    this._browserNavigation.addObserver(this._handleBrowserNavigation);
  }

  _processSorting() {
    const modelData = this._sortingModel.getData();

    this._buttonsViews.forEach((view) => {
      if (view.getSortName() === modelData.sortName) {
        if (view.isActive()) {
          const sortDir = this._sortingModel.getData().sortDir;
          const oldSortDir = (sortDir === SortDir.ASC) ?
            SortDir.DESC :
            SortDir.ASC;
          view.setSortDir(sortDir, oldSortDir);
        } else {
          view.activate();
        }
      } else {
        view.reset();
      }
    });

    const selectValue = (modelData.sortName === ``) ?
      `` :
      `${modelData.sortName}-${modelData.sortDir}`;

    this._sortingFormView.setSelectValue(selectValue);
  }

  _processLoadStart() {
    const sortName = this._sortingModel.getData().sortName;
    const activeButton = this._buttonsViews.find((view) => view.getSortName() === sortName);

    activeButton.setLoading();
  }

  _processLoadEnd() {
    this._buttonsViews.forEach((view) => view.setLoaded());
  }

  _handleChangeFilterLoadStart() {
    this._sortingModel.changeData(
        Object.assign(
            {},
            this._sortingModel.getData()
        ),
        ActionType.LOAD_START
    );
  }

  _handleChangeFilterLoad() {

  }

  _handleChangeFilterLoadEnd() {
    this._sortingModel.changeData(
        Object.assign(
            {},
            this._sortingModel.getData()
        ),
        ActionType.LOAD_END
    );
  }

  _handleBrowserNavigation(params) {
    let sorting = params
      .filter((item) => {
        return item.name === SORT_KEY;
      })
      .map((item) => {
        return item.values.trim();
      })
      .join(``);

    let sortName;
    let sortDir;

    if (sorting === ``) {
      sortName = ``;
      sortDir = ``;
    } else {
      [sortName, sortDir] = sorting.split(`-`);
    }

    this._sortingModel.changeData(Object.assign(
        {},
        this._sortingModel.getData(),
        {
          sortName,
          sortDir
        }
    ), ActionType.SORT);
  }

  _handleFormChange() {
    const sortingValue = this._sortingFormView.getSelectValue();

    this._changeFilter.updateProductsData({
      sort: sortingValue
    });

    const [sortName, sortDir] = (sortingValue)
      ? sortingValue.split(`-`)
      : [``, ``];

    this._sortingModel.changeData(Object.assign(
        {},
        this._sortingModel.getData(),
        {
          sortName,
          sortDir
        }
    ), ActionType.SORT);
  }

  _handleChangeData(action) {
    switch (action) {
      case ActionType.SORT:
        this._processSorting();
        break;
      case ActionType.LOAD_START:
        this._processLoadStart();
        break;
      case ActionType.LOAD_END:
        this._processLoadEnd();
        break;
    }
  }

  _handleButtonClick(evt, index) {
    evt.preventDefault();

    const activeView = this._buttonsViews[index];

    if (activeView.isLoading()) {
      return;
    }

    const isActive = activeView.isActive();

    let sortDir;
    const sortName = activeView.getSortName();

    if (isActive) {
      sortDir = (activeView.getSortDir() === SortDir.ASC) ?
        SortDir.DESC :
        SortDir.ASC;
    } else {
      sortDir = activeView.getSortDir();
    }

    if (!sortDir) {
      sortDir = ``;
    }

    const sortingValue = sortName !== `` ?
      `${sortName}-${sortDir}` : ``;

    this._changeFilter.updateProductsData({
      sort: sortingValue
    });

    this._sortingModel.changeData(Object.assign(
        {},
        this._sortingModel.getData(),
        {
          sortName,
          sortDir
        }
    ), ActionType.SORT);
  }
}
